define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"dojo/json",
	"csi",
	"csi/heading/AttributeController",
	"csi/utility/dateUtility",
	"csi/widget/Dialog",
	"csi/widget/MessageDialog",
	"csi/datasheet/Note",
	"csi/widget/Container"
], function(declare, lang, Memory, json, csi, AttributeController, {getTimeInMilliseconds}, Dialog, MessageDialog, Note, Container) {

	var _Dialog = declare(Dialog, {
		destroyOnHide: true,
		dialogActions: true,
		submitResource: "ShowCommentsHistory_Submit",
		cancelResource: "ShowCommentsHistory_Cancel",
		submitButtonToBePrimary: false,

		_parseJson: function(/*String*/value) {
			// summary: trying to convert the string value into a sorted array of comments
			if (value) {
				try {
					// support non-standard json
					value = value.replace(/{data:/, '{"data":');
					const cmtData = JSON.parse(value).data;
					cmtData.forEach((cmt) => {
						cmt.date = getTimeInMilliseconds(cmt.date);
					});
					return csi.sort(cmtData, "date");
				} catch (ex) {
					// return the original value if not valid json
				}
			}

			return value;
		},

		/**
		 * Focus secondary button
		 */
		onRenderDialogActions: function(div) {
			this.cancelButton.focusNode.tabIndex = 1;
		},

		buildRendering: function() {
			// summary: add browser view to dialog
			this.inherited(arguments);

			var comments = this._parseJson(this.value);
			var commentsData = comments.map(function(comment, id) {
				return {
					id: (id + 1),
					"author": comment.author,
					"text": comment.value,
					"time": comment.date
				};
			});

			var store = new Memory({
				data: commentsData
			});

			var commentsContainer = new Container({
				"class": "csi-canvas-notes csi-string-comment-popup",
				disabled: true,
				store: store,
				widgetClass: Note,
				widgetProperties: Note.widgetProperties
			});
			this.addChild(commentsContainer);
		}
	});

	return declare(AttributeController, {
		_dialog: null,

		getStringParameters: function() {
			// summary: parameterize dialog title with heading name
			return [this.heading.m_name];
		},

		preProcess: function() {
			// summary: open Comments history dialog.
			this.setProgress();

			var params = {
				title: this.getTitle(),
				value: this.oldValue,
				onSave: lang.hitch(this, this._onSave),
				onCancel: lang.hitch(this, this._onCancel)
			};

			this._dialog = new _Dialog(params);
			this._dialog.startup();
			this._dialog.show();
			this.setProgress(null);
		},

		postProcess: function(/*Boolean*/bStatus, /*Boolean*/bRepeat) {
			// summary: close the dialog
			if (this._dialog) {
				if (bStatus === false) {
					bRepeat = true;
					this._dialog.resumeAfterSave();
				} else {
					this._dialog.hide();
				}
			}

			this.inherited(arguments, [bStatus, bRepeat]);
		},

		_onSave: function(/*Object*/value) {
			// Get confirmation from user to delete all comments.
			this.confirmAction({
				title: this.getString("_Reset_Title"),
				message: this.getString("_Reset_Confirm"),
				buttons: [MessageDialog.BUTTON_RESET + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL],
				materialIcon: MessageDialog.ICON_ERROR,
				onResponse: lang.hitch(this, this._onResetComments)
			});
		},

		_onResetComments: function(/*String*/key) {
			// Remove all comments if user confirms.
			if (key == MessageDialog.BUTTON_RESET) {
				this.newValue = "";
				this.process();
			} else {
				this.postProcess();
			}
		},

		_onCancel: function() {
			this.postProcess();
		}
	});
});
